import * as THREE from 'three';
import { NewTimedObject3D } from '../new-timed-3d-object';

export class NewCollsionIndicator extends NewTimedObject3D {
  private radius: number;
  private color: string;
  private opacity: number;

  constructor(
    duration: number,
    radius: number = 0.05,
    color: string = '#E03131',
    opacity: number = 0.4
  ) {
    super(duration);

    this.radius = radius;
    this.color = color;
    this.opacity = opacity;

    const sphere = new THREE.Mesh(
      new THREE.SphereGeometry(this.radius, 8, 8),
      new THREE.MeshBasicMaterial({
        color: this.color,
        transparent: true,
        opacity: this.opacity,
      })
    );
    this.add(sphere);
  }
}
